<template>
  <v-card flat min-height="100">
    <v-row class="mx-auto fill-height" no-gutters justify="start">
      <v-col cols="12" md="4" class="px-md-1">
        <div class="d-inline-flex">
          <v-checkbox v-show="isFilter" class="mt-n1 align-end" dense
                      @change="filterValueChanged($event, 'headphones')"
                      hide-details v-model="filters.headphones"></v-checkbox>
          <v-switch :label="$vuetify.lang.t(`$vuetify.criticalDataset.${CriticalDatasetLabels.ACTIONS}.headphones`)"
                    :disabled="isFilter && !filters.headphones"
                    v-model="actionsEntry.headphones" hide-details></v-switch>
        </div>
      </v-col>

      <v-col cols="12" md="4" class="px-md-1">
        <div class="d-inline-flex">
          <v-checkbox v-show="isFilter" class="mt-n1 align-end" dense
                      @change="filterValueChanged($event, 'leftHandHidesBelt')"
                      hide-details v-model="filters.leftHandHidesBelt"></v-checkbox>
          <v-switch
            :label="$vuetify.lang.t(`$vuetify.criticalDataset.${CriticalDatasetLabels.ACTIONS}.leftHandHidesBelt`)"
            :disabled="isFilter && !filters.leftHandHidesBelt"
            v-model="actionsEntry.leftHandHidesBelt" hide-details></v-switch>
        </div>
      </v-col>

      <v-col cols="12" md="4" class="px-md-1">
        <div class="d-inline-flex">
          <v-checkbox v-show="isFilter" class="mt-n1 align-end" dense
                      @change="filterValueChanged($event, 'rightHandHidesBelt')"
                      hide-details v-model="filters.rightHandHidesBelt"></v-checkbox>
          <v-switch
            :label="$vuetify.lang.t(`$vuetify.criticalDataset.${CriticalDatasetLabels.ACTIONS}.rightHandHidesBelt`)"
            :disabled="isFilter && !filters.rightHandHidesBelt"
            v-model="actionsEntry.rightHandHidesBelt" hide-details></v-switch>
        </div>

      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { ActionsEntry } from '../../../models/criticalDataset/ActionsEntry'
import { CriticalDatasetLabels } from '../../../enum'
import criticalDatasetMixin from '../../../mixins/criticalDatasetMixin'

export default {
  name: 'criticalDatasetActions',
  mixins: [criticalDatasetMixin(ActionsEntry, 'actions')],
  props: {
    actionsEntry: ActionsEntry
  },
  created () {
    this['CriticalDatasetLabels'] = CriticalDatasetLabels
  }
}
</script>

<style scoped>

</style>
